import { boxFromCorners, boxOfPoints, inflateBox } from './markupConstraints.ts';
import type { Box, MarkupShape, TextShape } from './markupShapes.ts';
import { TEXT_LINE_HEIGHT } from './markupStyle.ts';

// Width of `text` in image pixels at `fontSize`; the browser measures with a canvas.
export type TextMeasure = (text: string, fontSize: number) => number;

export function textBox(shape: TextShape, measure: TextMeasure): Box {
    return {
        x: shape.at.x,
        y: shape.at.y,
        width: measure(shape.text, shape.fontSize),
        height: shape.fontSize * TEXT_LINE_HEIGHT
    };
}

// The box a selection frame and its handles sit on; a pen frame clears the stroke's ink.
export function frameBox(shape: MarkupShape, measure: TextMeasure): Box {
    switch (shape.kind) {
        case 'rect':
        case 'ellipse':
            return shape.box;
        case 'pen':
            return inflateBox(boxOfPoints(shape.points), shape.width / 2);
        case 'arrow':
        case 'line':
            return boxFromCorners(shape.from, shape.to);
        case 'text':
            return textBox(shape, measure);
    }
}

const SELECTION_GAP_SCREEN_PX = 4;

// Image pixels between a mark's frame and its selection outline, so the outline never hides the ink.
export function selectionPad(shape: MarkupShape, screenPx: number): number {
    const gap = SELECTION_GAP_SCREEN_PX * screenPx;
    if (shape.kind === 'rect' || shape.kind === 'ellipse') return shape.width / 2 + gap;
    return shape.kind === 'arrow' || shape.kind === 'line' ? 0 : gap;
}
